import siteData from "./generated/site-data.json";

const {
  settings,
  pages = [],
  serviceCategoryPages = [],
  services = [],
  profileProjects = siteData.projects ?? [],
} = siteData;

function esc(s) {
  const d = document.createElement("div");
  d.textContent = s;
  return d.innerHTML;
}

function isPlaceholderContact() {
  const email = settings.contactEmail ?? "";
  return email.includes("example") || email.includes("placeholder");
}

function renderHome() {
  const el = document.getElementById("home");
  const categories = serviceCategoryPages
    .slice()
    .sort((a, b) => a.sortOrder - b.sortOrder)
    .map((c) => `<li><span class="service-chip">${esc(c.title)}</span></li>`)
    .join("");
  el.innerHTML = `
    <div class="section-shell hero__body">
      <p class="eyebrow">Electrical Engineering Services</p>
      <h1 id="hero-heading">${esc(settings.businessName)}</h1>
      <div class="section-stack">
        <p class="lead">${esc(settings.tagline ?? "")}</p>
        <p class="lead">
          We deliver testing, commissioning, and engineering support for industrial and utility electrical systems across Pakistan and the region.
        </p>
      </div>
      <div class="hero__services">
        <h2 class="subheading">Services Categories</h2>
        <ul class="service-links">${categories}</ul>
      </div>
    </div>
  `;
}

function renderAbout() {
  const el = document.getElementById("about");
  el.innerHTML = `
    <div class="section-shell section-stack">
      <p class="eyebrow">Who We Are</p>
      <h2 id="about-heading">About Us</h2>
      <p>
        We are an electrical engineering services company focused on dependable power systems for utility and industrial clients.
        Our expertise spans design support, commissioning, diagnostics, and long-term system reliability improvements.
      </p>
    </div>
  `;
}

function renderServicesOverview() {
  const el = document.getElementById("services");
  const sorted = [...services].sort((a, b) => a.sortOrder - b.sortOrder);
  el.innerHTML = `
    <div class="section-shell section-stack">
      <p class="eyebrow">Core Offerings</p>
      <h2 id="services-heading">Services</h2>
      <ul class="services-list">
        ${sorted
          .map(
            (s) => `
          <li>
            <article class="service-card">
              <div class="service-card__content">
                <h3>${esc(s.title)}</h3>
                <p>${esc(s.summary)}</p>
                ${
                  s.mappedCategoryKey
                    ? `<a class="text-link" href="#service-${esc(s.mappedCategoryKey)}">Learn more</a>`
                    : ""
                }
              </div>
            </article>
          </li>`
          )
          .join("")}
      </ul>
    </div>
  `;
}

function renderProfile() {
  const el = document.getElementById("profile");
  const sorted = [...profileProjects].sort((a, b) => a.sortOrder - b.sortOrder);
  const carouselItems = sorted.filter((p) => p.imagePath && p.imagePath.includes("/images/projects/"));
  el.innerHTML = `
    <div class="section-shell section-stack">
      <p class="eyebrow">Selected Work</p>
      <h2 id="profile-heading">Profile</h2>
      <p class="lead">Representative engagements and field work snapshots from recent projects.</p>
      ${
        carouselItems.length
          ? `
      <section class="field-carousel section-stack" aria-label="Field work image carousel">
        <h3>Field Work</h3>
        <div class="field-carousel__viewport">
          ${carouselItems
            .map(
              (p, idx) => `
            <figure class="field-carousel__slide${idx === 0 ? " is-active" : ""}" data-slide-index="${idx}">
              <img src="${encodeURI(p.imagePath)}" alt="${esc(p.imageAlt)}" width="1200" height="675" loading="lazy" />
              <figcaption>${esc(p.name)}</figcaption>
            </figure>`
            )
            .join("")}
        </div>
        <div class="field-carousel__controls">
          <button type="button" class="field-carousel__btn" data-carousel-action="prev" aria-label="Previous image">Previous</button>
          <span class="field-carousel__status" aria-live="polite">1 / ${carouselItems.length}</span>
          <button type="button" class="field-carousel__btn" data-carousel-action="next" aria-label="Next image">Next</button>
        </div>
      </section>`
          : ""
      }
      <div class="projects-table-wrap">
        <table class="projects-table">
          <thead>
            <tr>
              <th>Project</th>
              <th>Scope</th>
              <th>Role</th>
              <th>Client</th>
            </tr>
          </thead>
          <tbody>
            ${sorted
              .map(
                (p) => `
            <tr>
              <td>${esc(p.name)}</td>
              <td>${esc(p.scope)}</td>
              <td>${esc(p.role || "Not specified")}</td>
              <td>${esc(p.client || "Not specified")}</td>
            </tr>`
              )
              .join("")}
          </tbody>
        </table>
      </div>
    </div>
  `;
}

function setupProfileCarousel() {
  const root = document.querySelector(".field-carousel");
  if (!root) return;
  const slides = [...root.querySelectorAll(".field-carousel__slide")];
  const status = root.querySelector(".field-carousel__status");
  const prevBtn = root.querySelector('[data-carousel-action="prev"]');
  const nextBtn = root.querySelector('[data-carousel-action="next"]');
  if (!slides.length || !status || !prevBtn || !nextBtn) return;

  let index = 0;
  let timer = null;

  const update = (nextIndex) => {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, i) => {
      slide.classList.toggle("is-active", i === index);
    });
    status.textContent = `${index + 1} / ${slides.length}`;
  };

  const start = () => {
    if (slides.length < 2) return;
    stop();
    timer = window.setInterval(() => update(index + 1), 3200);
  };

  const stop = () => {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  };

  prevBtn.addEventListener("click", () => {
    update(index - 1);
    start();
  });
  nextBtn.addEventListener("click", () => {
    update(index + 1);
    start();
  });
  root.addEventListener("mouseenter", stop);
  root.addEventListener("mouseleave", start);
  root.addEventListener("focusin", stop);
  root.addEventListener("focusout", start);

  update(0);
  start();
}

function renderNav() {
  const nav = document.querySelector(".site-nav ul");
  if (!nav || !pages.length) return;
  const sorted = [...pages].sort((a, b) => a.sortOrder - b.sortOrder).filter((p) => p.visible);
  nav.innerHTML = sorted
    .map((p) => `<li><a href="#${esc(p.key)}">${esc(p.navLabel)}</a></li>`)
    .join("");
  const setCurrent = () => {
    const current = window.location.hash.replace("#", "") || "home";
    nav.querySelectorAll("a").forEach((a) => {
      const isCurrent = a.getAttribute("href") === `#${current}`;
      if (isCurrent) a.setAttribute("aria-current", "page");
      else a.removeAttribute("aria-current");
    });
  };
  window.addEventListener("hashchange", setCurrent);
  setCurrent();
}

function renderContact() {
  const el = document.getElementById("contact");
  const email = settings.contactEmail ?? "";
  const phone = settings.contactPhone ?? "";
  const address = settings.address ?? "";
  const placeholder = isPlaceholderContact();

  el.innerHTML = `
    <div class="section-shell section-stack">
      <p class="eyebrow">Reach Out</p>
      <h2 id="contact-heading">Contact</h2>
      <div class="contact-grid">
        ${
          email
            ? `<p class="contact-item"><strong>Email</strong><br /><a href="mailto:${encodeURIComponent(email)}">${esc(email)}</a></p>`
            : ""
        }
        ${
          phone
            ? `<p class="contact-item"><strong>Phone</strong><br /><a href="tel:${esc(phone.replace(/\s/g, ""))}">${esc(phone)}</a></p>`
            : ""
        }
        ${address ? `<p class="contact-item"><strong>Address</strong><br />${esc(address)}</p>` : ""}
      </div>
      ${
        placeholder
          ? `<p class="contact-note" role="status">Placeholder contact details — confirm email, phone, and address before public launch.</p>`
          : ""
      }
    </div>
  `;
}

function renderFooter() {
  const el = document.getElementById("footer-copy");
  const y = new Date().getFullYear();
  el.innerHTML = `© ${y} ${settings.businessName}. All rights reserved. <a href="#contact">Get in touch</a>`;
}

renderNav();
renderHome();
renderAbout();
renderProfile();
setupProfileCarousel();
renderServicesOverview();
renderContact();
renderFooter();
